////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { map, isEmpty } from 'lodash'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { languagesActionCreators } from '../../store/actions'

/////////STYLED/////////
const FlagImgWrapper = styled.img`
	max-width: 26px;
	height: 17px;
	cursor: pointer;
	box-sizing: content-box;
	border: ${(props) => (props.selectedLanguage ? `1px solid ${props.theme.colors.primary}` : 'none')};
	border-radius: 3px;
	margin: 0px 10px;
`
/////////STYLED/////////

const SwitchLanguage = ({ scope, ...rest }) => {
	const { languagesList, selectedLanguage } = useSelector(
		(state) => ({
			languagesList: state.languages.items,
			selectedLanguage: state.languages.selectedLanguage,
		}),
		shallowEqual
	)

	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())

	const [currentLanguagesList, setCurrentLanguagesList] = useState([])

	///////////////////////////////// HANDLE ///////////////////////////////////////
	/**
	 * call to change user languages
	 * @param   {string}        idLanguage
	 * @param   {string}        scope for language ( e.g 'public' || 'private' )
	 */
	const handleLanguage = (idLanguage, scope) => {
		if (scope === 'private') {
			actionsLanguages.getTranslationByLanguages(idLanguage)
		} else {
			actionsLanguages.getTranslationPublicPage(idLanguage)
		}
	} // end function

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isEmpty(languagesList)) {
			// Copie avant tri : Array.sort mute le tableau, et languagesList est la reference
			// detenue par le store redux. Comparateur numerique aussi : l'ancien renvoyait un
			// booleen, jamais de valeur negative, donc le tri n'etait pas fiable.
			const ord = [...languagesList].sort((a, b) => String(a?.labelEnglish ?? '').localeCompare(String(b?.labelEnglish ?? '')))
			setCurrentLanguagesList(ord)
		}
	}, [languagesList])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return map(currentLanguagesList, (elem, id) => {
		return (
			<FlagImgWrapper
				key={elem?.id ?? id}
				src={`/${elem?.picturePath}`}
				selectedLanguage={selectedLanguage === elem?.id}
				onClick={() => handleLanguage(elem?.id, 'public')}
				scope="public"
			/>
			/* 	<Base64Images
					key={ id }
					base64={ elem.picture_path }
					width='26'
					height='17'
					idElem={ elem.id }
					scope={ scope }
					click={ handleLanguage }
				/> */
		)
	})
}

SwitchLanguage.propTypes = {}

SwitchLanguage.defaultPropTypes = {}

export default SwitchLanguage
